// Soft logo strip: muted, link-only, no cards. Credibility markers earn their place by being quiet;
// a loud "AS FEATURED IN" band reads like it is compensating for something.
import { VIKAS_PRESS } from './vikasPress';
import { BrandLogo, logoForHref } from '@/lib/brandLogos';

export default function VikasPressStrip({ heading = 'Contributions & features', className = '' }) {
  if (!VIKAS_PRESS.length) return null;
  return (
    <section className={`max-w-3xl mx-auto px-6 py-12 border-t border-gray-100 ${className}`} data-testid="vikas-press">
      <h2 className="text-[10px] font-bold text-black uppercase tracking-widest mb-6">{heading}</h2>
      <ul className="flex flex-wrap items-center gap-x-8 gap-y-5">
        {VIKAS_PRESS.map((p) => (
          <li key={p.url}>
            <a
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              title={p.title}
              aria-label={`${p.kind} in ${p.outlet}: ${p.title}`}
              className="group inline-flex flex-col gap-1 opacity-50 hover:opacity-100 transition-opacity focus:opacity-100"
            >
              {p.logo ? (
                <img src={p.logo} alt={p.outlet} className="h-6 w-auto grayscale group-hover:grayscale-0 transition-[filter]" loading="lazy" />
              ) : (
                <span className="text-base font-serif font-bold text-black">
                  <BrandLogo slug={logoForHref(p.url)} className="grayscale group-hover:grayscale-0 transition-[filter]" />
                  {p.outlet}
                </span>
              )}
              <span className="text-[10px] uppercase tracking-widest text-black">{p.kind}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
